import React, { Component } from 'react'
import { Helmet } from "react-helmet";
import loadable from '@loadable/component'

import { DEF_MAGNITT_DESCRIPTION, HUBSPOT_FORM_SOURCE } from '/src/lib/constants';
import { WEB_URL } from '/src/lib/endpoints'
import { faqs } from '/src/lib/faq'


const DemoRequest = loadable(() => import(/* webpackChunkName: "DemoRequest" */ '/src/components/Pricing/DemoRequest'));



class FAQ extends Component {

    constructor() {
        super();
    }

    showFAQs = () => {
        let faqContent = [];
        for (let i in faqs) {
            { /* first q is expanded by default */ }
            faqContent.push(
                <div className="info-box-container" key={i}>
                    <div className="info-box-title" data-toggle="collapse" href={"#faq-" + i} aria-expanded={i == 0 ? "true" : "false"}>
                        {faqs[i].question}
                    </div>
                    <div className={i == 0 ? "info-box-body collapse show" : "info-box-body collapse hide"} id={"faq-" + i}>
                        {faqs[i].answer}
                    </div>
                </div>
            )
        }
        return (faqContent);
    }

    render() {
        return (
            <div>
                <Helmet>
                    <meta property="og:site_name" content="MAGNiTT" />
                    <meta property="og:type" content="article" />
                    <meta property="og:url" content={`${WEB_URL}/faq`} />
                    <meta property="og:title" content="FAQ" />
                    <title>FAQ | MAGNiTT</title>
                    <meta name="HandheldFriendly" content="true" />
                    <meta name="MobileOptimized" content="width" />
                    <meta name="description" content={DEF_MAGNITT_DESCRIPTION} />
                    <meta name="abstract" content={DEF_MAGNITT_DESCRIPTION} />
                    {/* <meta name="keywords" content="Funding, statistics, startups, investors, MAGNiTT, News, Research" /> */}
                    <link rel='canonical' href={`${WEB_URL}/faq`} />
                    <script type="application/ld+json">
                        {`
                        {
                            "@context": "http://schema.org",
                            "@type": "BreadcrumbList",
                            "itemListElement": [{
                                "@type": "ListItem",
                                "position": 1,
                                "name": "FAQ",
                                "item": "${WEB_URL}/faq"
                            }]
                        }
                        `}
                    </script>
                </Helmet>

                <section className="directory content-box pricing">

                    <div className="page-header">
                        <h1 className="text-dark">
                            Frequently Asked Questions
                        </h1>
                        <p>
                            Your access point for startups &amp; investor data in 19 emerging venture markets and counting
                        </p>
                    </div>

                    <div className="row flex-grow-1">
                        <div className="col-lg-9 m-auto">
                            <div className="mid-width-info-box">
                                {this.showFAQs()}
                            </div>
                        </div>
                    </div>

                    <DemoRequest id="demo-request" btnClasses="d-none" page={HUBSPOT_FORM_SOURCE.faq}/>

                </section>

            </div>
        )

    }
}

export default FAQ;
